(function () {
  const host = Shopify.shop;
  const options = {
    "owner-club.myshopify.com": {
      basePath: "https://api2.speediance.top/api2/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      //日语
      acceptLanguage: "en",
    },
    "bc91e5-2b.myshopify.com": {
      basePath: "https://api2.speediance.com/api/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      //英语
      acceptLanguage: "en",
    },
    "b66830-2.myshopify.com": {
      basePath: "https://euapi.speediance.com/api/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      //德语
      acceptLanguage: "de",
    },
    "214d1e-7a.myshopify.com": {
      basePath: "https://api2.speediance.com/api/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      acceptLanguage: "ja-JP",
    },
    // TODO 5个站点配置
  };
  const occHttpRequest = (requestOpt) => {
    if (!options[host]) {
      return Promise.reject(
        new Error(`OCC config is missing for host: ${host}`),
      );
    }

    const { basePath, apiAuthKey, shopifyStoresFlag, acceptLanguage } =
      options[host];
    const { body } = requestOpt;

    let reqBody = body ? body : {};
    reqBody = { shopifyStoresFlag, shopifyUserId: getCustomerId(), ...reqBody };

    return fetch(basePath + requestOpt.path, {
      method: requestOpt.method || "POST", // 后端提供的接口都是POST，所以默认POST
      body: JSON.stringify(reqBody),
      headers: new Headers({
        "Content-Type": "application/json",
        apiAuthKey,
        "Accept-Language": acceptLanguage || "en",
      }),
      mode: "cors",
    });
  };
  // 获取列表
  const fetchOccDtcActivityList = async () => {
    const res = await occHttpRequest({
      path: "fetchDtcActivityList",
      method: "POST",
      body: {},
    });
    return res.json();
  };
  // 获取详情
  const fetchOccDtcActivityDetail = async (data) => {
    const res = await occHttpRequest({
      path: "fetchDtcActivity",
      method: "POST",
      body: data,
    });
    return res.json();
  };
  // 兑换折扣
  const fetchOccExchangeActivityWelfare = async (data) => {
    const res = await occHttpRequest({
      path: "exchangeActivityWelfare",
      method: "POST",
      body: data,
    });
    return res.json();
  };

  window.fetchOccDtcActivityList = fetchOccDtcActivityList;
  window.fetchOccDtcActivityDetail = fetchOccDtcActivityDetail;
  window.fetchOccExchangeActivityWelfare = fetchOccExchangeActivityWelfare;
})();
